/**
 * @generated SignedSource<<95f7f280f50612f1235a722c352e0ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_TranscriptSegment_meetingRecording$data = {
  readonly id: string;
  readonly ownerAccount: {
    readonly __typename: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"utils_useGetURL_recording">;
  readonly " $fragmentType": "TranscriptPanel_TranscriptSegment_meetingRecording";
};
export type TranscriptPanel_TranscriptSegment_meetingRecording$key = {
  readonly " $data"?: TranscriptPanel_TranscriptSegment_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_TranscriptSegment_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_TranscriptSegment_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useGetURL_recording"
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};

(node as any).hash = "945dc191e6bb0065f411d1be2f7c1534";

export default node;
